interface Props {
    text?: string;
    type?: "submit" | "reset" | "button" | undefined;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function SaveButton({ text, type, disabled, onClick }: Props) {

    return (
        <button 
            onClick={onClick}
            disabled={disabled}
            type={type ?? "submit"}
            className="bg-green-800 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center disabled:opacity-50">
            <p className="text-white text-[13px] font-semibold text-center">{text ?? "Guardar"}</p>
        </button>
    );
}